<template>
  <div class="content">
    <div class="container-fluid support">
      <div class="row">
        <div class="col-md-6">
          <card>
            <template slot="header">
              {{ support_title }}
            </template>
            <template>
              <div class="row spacer-sm">
                <div class="col">
                  <p class="support-message">{{ support_message }}</p>
                </div>
              </div>
              <div class="row spacer-md">
                <div class="col">
                  <img class="peter" src="@/assets/static/img/peter.png" alt="..."/>
                  <div class="caption">
                    <div class="caption-name">{{ img_name }}</div>
                    <div class="caption-description">{{ img_description }}</div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <fg-input type="text"
                            label="Name"
                            placeholder="Name"
                            :isRequired="true"
                            v-model="name">
                  </fg-input>
                </div>
                <div class="col-md-6">
                  <fg-input type="text"
                            label="Email"
                            placeholder="Email"
                            :isRequired="true"
                            v-model="email">
                  </fg-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <fg-textarea
                    :rows=6
                    :label="feedback_label"
                    :placeholder="feedback_placeholder"
                    :isRequired="true"
                    v-model="feedback_input">
                  </fg-textarea>
                </div>
              </div>
              <div class="row spacer-md">
                <div class="col">
                  <fg-file
                    :label="file_upload_label"
                    v-on:handleFileUpload="handleFileUpload">
                  </fg-file>
                </div>
              </div>
              <div class="row spacer-md">
                <div class="container d-flex justify-content-center">
                  <default-button :buttonText="submit_request" :processing-click="submitting" v-on:onButtonClicked="submitSupportRequest" />
                </div>
              </div>
            </template>
          </card>
        </div>
        <div class="col-md-6">
          <card>
            <template slot="header">
              {{ resources_title }}
            </template>
            <template>
              <ul class="helpful-links-list">
                <li v-for="helpful_link in helpfulLinks" :key="helpful_link.title">
                  <a :href="helpful_link.url" target="_blank">{{ helpful_link.title }}</a> 
                </li>
              </ul>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Card from '@/components/UIComponents/Cards/Card.vue'
  import DefaultButton from '@/components/UIComponents/Buttons/DefaultButton.vue'

  export default {
    components: {
      Card,
      DefaultButton,
    },
    data: function () {
      return {
        errors: [],
        support_title: "Support",
        support_message: "We want to make Plyo a platform you love. If you're looking for help, please let us know and we'll get back to you within 24 hours.",
        img_name: "Peter",
        img_description: "Co-Founder of Plyo",
        resources_title: "Helpful Resources",
        name: "",
        email: "",
        feedback_label: "What can we help you with?",
        feedback_placeholder: "Share all the details. The more we know, the better we can help you.",
        feedback_input: "",
        file_upload_label: "Attach a file, screenshot, or document",
        file: '',
        submit_request: "SUBMIT",
        submitting: false,
      }
    },
    methods: {
      handleFileUpload (file) {
        if (file) {
          if (file.size < 4000000) {
            this.file = file;
          } {
            // File is too big
          }
        } else {
          this.file = '';
        }
      },
      async submitSupportRequest () {
        if (!this.submitting) {
          this.submitting = true
          await this.$store.dispatch('inspectToken');

          if (this.$store.getters.isLoggedIn) {
            this.checkForErrors()
            if (!this.errors.length) {
              var formData = new FormData()

              if (this.file) {
                formData.append('file', this.file);
              }

              formData.append('name', this.name);
              formData.append('email', this.email);
              formData.append('feedback', this.feedback_input);

              const header = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `JWT ${this.$store.state.jwt.jwt}`,
                }
              }

              await axios.post(this.$store.state.endpoints.feedback, formData, header)
                .then((response)=>{
                  /* eslint-disable-next-line */
                  console.log(response);
                  // notify of success
                  this.submitting = false;
                })
                .catch((error)=>{
                  /* eslint-disable-next-line */
                  console.log(error);
                  // notify of failure
                  this.submitting = false;
                })
              this.goToAnalytics();
            } else {
              this.submitting = false;
              // show errors
            }
          } else {
            this.$router.push('/login')
          }
        }
      },
      checkForErrors () {
        this.errors = [];
        if (this.name.length === 0) {
          this.errors.push('Please provide a name.')
        }
        if (this.email.length === 0) {
          this.errors.push('Please provide an email.')
        }
        if (this.feedback_input.length === 0) {
          this.errors.push('Please provide some of the details, so we can help you.')
        }
      },
      goToAnalytics() {
        this.$store.dispatch('setModalTitle', { title: 'Request Submitted!' })
        this.$store.dispatch('setSVGType', { svg_type: 'checkmark' })
        this.$store.dispatch('setModalMessage', { message: 'redirecting...' })
        this.$store.dispatch('setModalVisible', { visible: true })
        const self = this;
        setTimeout(function () { 
            self.$router.push('/analytics'); 
            self.$store.dispatch('setModalVisible', { visible: false })
          }, 2000)
      },
    },
    computed: {
      isRestaurant () {
        return this.$store.getters.advertiser.company_type === "Restaurant";
      }, 
      isOnlineRetailStore () {
        return this.$store.getters.advertiser.company_type === "Online Retail Store";
      },
      helpfulLinks () { 
        var helpful_links = [
          { title: 'Merchant Dashboard Tutorial Video', url: 'https://plyoapp.wistia.com/medias/qnt4vsvq2f', },
          { title: 'Cashier Instructions PDF', url: 'https://s3-us-west-2.amazonaws.com/plyo-merchant-resources/Plyo+Cashier+Instructions.pdf', },
        ];

        if (this.$store.getters.advertiser.company_type === "Restaurant") {
          helpful_links.splice(1, 0, { title: 'Rewards Guide', url: 'https://s3-us-west-2.amazonaws.com/plyo-merchant-resources/Getting+Started+Guide+-+Restaurants.pdf', });
        } else if (this.$store.getters.advertiser.company_type === "Online Retail Store") {
          helpful_links.splice(1, 0, { title: 'Rewards Guide', url: 'https://s3-us-west-2.amazonaws.com/plyo-merchant-resources/Getting+Started+Guide+-+Online+Retail.pdf', });
        } else if (this.$store.getters.advertiser.company_type === "Physical Retail Store") {
          helpful_links.splice(1, 0, { title: 'Rewards Guide', url: 'https://plyo-merchant-resources.s3-us-west-2.amazonaws.com/Getting+Started+Guide+-+In-Store+Retail.pdf', });
        }

        return helpful_links
      },
    },
    mounted: function () {
      this.$nextTick(() => {
        this.$emit('scrollTop', 0)
      });
      this.name = this.$store.getters.user.first_name + ' ' + this.$store.getters.user.last_name;
      this.email = this.$store.getters.user.email;
    }
  }
</script>
